import { Routes } from '@angular/router';
import { HandoverInspAppearComponent } from './handover-insp-appear/handover-insp-appear.component';
import { HandoverInspEntityCheckComponent } from './handover-insp-entity-check/handover-insp-entity-check.component';
import { HandoverInspEntityReportComponent } from './handover-insp-entity-report/handover-insp-entity-report.component';
import { HandoverInspEntitySubmitComponent } from './handover-insp-entity-submit/handover-insp-entity-submit.component';
import { HandoverInspEntityViewComponent } from './handover-insp-entity-view/handover-insp-entity-view.component';
import { HandoverInspEntityComponent } from './handover-insp-entity/handover-insp-entity.component';
import { HandoverInspLoadComponent } from './handover-insp-load/handover-insp-load.component';
import { HandoverInspPlanComponent } from './handover-insp-plan/handover-insp-plan.component';
import { HandoverInspReportViewAppearComponent } from './handover-insp-report-view-appear/handover-insp-report-view-appear.component';
import { HandoverInspReportViewLoadComponent } from './handover-insp-report-view-load/handover-insp-report-view-load.component';

export const handoverRoutes: Routes = [
  {
    path: 'entity',
    data: {
      title: '实体检测',
    },
    component: HandoverInspEntityComponent,
  },
  {
    path: 'load',
    data: {
      title: '荷载试验',
    },
    component: HandoverInspLoadComponent,
  },
  {
    path: 'appearance',
    data: {
      title: '外观检查',
    },
    component: HandoverInspAppearComponent,
  },
  {
    path: 'plan',
    data: {
      title: '检测方案',
    },
    component: HandoverInspPlanComponent,
  },
  {
    path: '',
    redirectTo: 'entity',
    pathMatch: 'full',
  },
];

export const entityRoutes: Routes = [
  {
    path: 'check/:jgSectionId/:sectionId',
    data: {
      title: '交工报检',
    },
    component: HandoverInspEntityCheckComponent,
  },
  {
    path: 'submit/:jgSectionId/:sectionId',
    data: {
      title: '交工报检提交',
    },
    component: HandoverInspEntitySubmitComponent,
  },
  {
    path: 'view',
    data: {
      title: '交工报检视图',
    },
    component: HandoverInspEntityViewComponent,
  },
  {
    path: 'report/:jgSectionId/:sectionId',
    data: {
      title: '检测报告提交',
    },
    component: HandoverInspEntityReportComponent,
  },
  {
    path: 'view-report-load/:id',
    data: {
      title: '',
    },
    component: HandoverInspReportViewLoadComponent,
  },
  {
    path: 'view-report-appear/:id',
    data: {
      title: '',
    },
    component: HandoverInspReportViewAppearComponent,
  },
];
